import { MaintenanceAlert } from "components/common";
import { SearchWithFilter } from "components/search";

const ProvematerialePage = () => {
  return (
    <>
      <MaintenanceAlert />
      <SearchWithFilter />
    </>
  );
};

export default ProvematerialePage;
